import { Fragment, type ReactElement } from "react";

/** フォームの受付件数の 1 か月ぶん（サーバの FormUsageRow と同じ欄）。 */
export interface FormUsageRow {
    /** 「今月」「2026年8月」。 */
    readonly monthLabel: string;
    /** 「350 / 1,000 件（残り 650 件）」「820 件（上限 1,000 件）」「記録なし」。 */
    readonly usageLabel: string;
    readonly isCurrent: boolean;
}

/**
 * フォームの月ごとの受付件数（サーバの FormUsagePanel と同じ欄。Implem.Portal.Backend の docs/features/16 §6）。
 * <b>フォーム機能を付けている契約にだけサーバが付ける</b>（会員の画面は契約者、管理センターは請求を見られる人だけ。それ以外は null）。
 */
export interface FormUsage {
    readonly heading: string;
    /** 新しい月から順に。先頭が今月。 */
    readonly months: readonly FormUsageRow[];
}

/**
 * 会員の契約情報と管理センターの契約の状況に出す、フォームの受付件数の表。<b>文言はサーバが作り、ここは並べるだけ</b>
 * （残りの計算も「記録なし」の判定もしない）。
 */
export function FormUsagePanel({ usage }: { readonly usage: FormUsage }): ReactElement {
    return (
        <section className="mb-6" data-form-usage="">
            <h3 className="mb-2 text-sm font-semibold text-slate-700">{usage.heading}</h3>
            <dl className="grid grid-cols-[8rem_1fr] gap-y-1 text-sm">
                {usage.months.map((month) => (
                    <Fragment key={month.monthLabel}>
                        <dt className="text-slate-500">{month.monthLabel}</dt>
                        <dd className={month.isCurrent ? "font-semibold text-slate-900" : undefined}>{month.usageLabel}</dd>
                    </Fragment>
                ))}
            </dl>
        </section>
    );
}
